/**
 * Public paid/premium membership is hidden while this is false.
 *
 * Flip to `true` to restore the $199 yearly checkout, plan tabs, and upgrade
 * prompts. Stripe products, webhooks, admin billing, and existing paid
 * entitlements stay in the codebase either way.
 *
 * Event-ticket checkout is separate and is not gated by this flag.
 */
export const MEMBERSHIP_PAID_TIERS_ENABLED = false;

export const MEMBERSHIP_JOIN_CTA = MEMBERSHIP_PAID_TIERS_ENABLED ? "Join Now" : "Join free";

export const MEMBERSHIP_PUBLIC_PRICE_COPY = MEMBERSHIP_PAID_TIERS_ENABLED
  ? "Full member bios, verified profile links, priority event registration, and the member badge — $199/year, billed securely through Stripe."
  : "Full member bios, verified profile links, priority event registration, and the member badge — membership is free.";
